import React from 'react';

const IconArrowUp = props => (
  <svg viewBox="0 0 350 350" {...props}>
    <path d="M298.055 147.199c0 2.787-1.267 9.271-13.036 9.271h-54.037v178.856c.072.48.144 1.159.144 1.939 0 3.177-1.207 6.106-3.416 8.269-2.858 2.798-7.224 4.222-12.988 4.222h-83.056c-11.493 0-14.525-8.149-14.525-12.454V160.236H67.606c-13.841 0-15.904-6.594-15.904-10.521 0-6.293 5.996-12.577 7.197-13.775 3.176-4.305 89.036-118.195 101.529-130.718 4.558-4.534 9.131-5.339 12.163-5.209 7.293.3 12.268 5.915 12.808 6.56l104.838 126.674c1.513 1.384 7.818 7.821 7.818 13.952z" />
  </svg>
);

export default IconArrowUp;
